/**
 * @generated SignedSource<<257e9297535a04bbf073fd8fccb645c0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_videoVimeo$data = {
  readonly __typename: "VideoVimeo";
  readonly " $fragmentType": "useItemMediaItems_videoVimeo";
};
export type useItemMediaItems_videoVimeo$key = {
  readonly " $data"?: useItemMediaItems_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemMediaItems_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "eb3c061438a764589750f1f84c54bfae";

export default node;
